import axios from 'axios';
import createAxios from "../../../../app/javascript/dashboard/helper/ThirdServerAPIHelper"
const DEFAULT_API_VERSION = 'v1';

class ThirdServerAPI {
  constructor() {
    // super(); // 调用父类的构造函数
    this.axios = createAxios(axios);
    this.url =  `/${DEFAULT_API_VERSION}/api/`
  }
  subscription() {
    console.info("ThirdServerAPI this.url: ", this.url)
    return this.axios.post(`${this.url}billing/subscription`);
  }

  checkout() {
    console.info("ThirdServerAPI this.url: ", this.url, this.axios)
    return this.axios.post(`${this.url}billing/create-session`);
  }

  checkoutTraffic(data) {
    console.info("checkoutTraffic: ", data)
    return this.axios.post(`${this.url}billing/checkout-session`, data);
  }

  //查看merchant详情
  getMerchant() {
    return this.axios.get(`${this.url}chatapp/merchant/get`);
  }

  // 切换商户使用gpt的状态
  toggleMerchantGPT(data) {
    return this.axios.post(`${this.url}chatapp/merchant/toggle-gpt`, data);
  }

  // 发布话术
  publishMerchantTalk() {
    return this.axios.post(`${this.url}chatapp/merchant/prompt/publish`);
  }

  // 更改商户的shopify data
  updateMerchantShop(data) {
    return this.axios.post(`${this.url}chatapp/merchant/shops`, data);
  }

  // 更改商户的话术文档
  updateMerchantScriptRecord(data) {
    return this.axios.post(`${this.url}chatapp/merchant/script/update`, data);
  }

  // 创建商户的prompt
  createMerchantPrompt(data) {
    return this.axios.post(`${this.url}chatapp/merchant/prompt/create`, data);
  }

  // 获取商户的prompt
  scanMerchantPrompts(data) {
    return this.axios.get(`${this.url}chatapp/merchant/prompt/scan`, data);
  }

  // 删除prompt
  deleteMerchantPrompt(data) {
    return this.axios.post(`${this.url}chatapp/merchant/prompt/delete`, data);
  }

  // 更新prompt的状态
  updateMerchantPromptStatus(data) {
    return this.axios.post(`${this.url}chatapp/merchant/prompt/toggle-status`, data);
  }

  // 更新prompt的数据
  updateMerchantPromptData(data) {
    return this.axios.post(`${this.url}chatapp/merchant/prompt/update`, data);
  }

  // 查看房间的gpt状态
  getRoomDetail(data) {
    return this.axios.get(`${this.url}chatapp/merchant/room/get`, {
      params: data
  });
  }

  // 开启gpt
  enableRoomGPT(data) {
    return this.axios.post(`${this.url}chatapp/merchant/room/enable`, data);
  }
  // 关闭gpt
  disabledRoomGPT(data) {
    return this.axios.post(`${this.url}chatapp/merchant/room/disable`, data);
  }

  // 获取shopify的商品列表
  getShopifyProducts() {
    return this.axios.get(`${this.url}chatapp/merchant/shopify-product/scan`);
  }

  // 获取shopify的商品列表
  getShopifyOrders() {
    return this.axios.get(`${this.url}chatapp/merchant/shopify-order/scan`);
  }
}

export default new ThirdServerAPI();